/**
* @author Edgar Escobedo
* @description Obtiene los creditos por paginas de documento
* @updatedDate 27-08-2024
* @param {Number} number 
* @returns {Array}
*/
const countCreditsByPages = (pages, credits, addPages) => {
    let afterPages = addPages
    let totalCredits = 0

    totalCredits = totalCredits + credits
    while (pages > afterPages) {
        totalCredits = totalCredits + credits
        afterPages += addPages
    }
    return totalCredits
}

/**
 * @author Pedro Antonio
 * @param {File} object
 * @param {string} property
 */
const getFileMediaType = (object, property) => {
    if (!object || !object[property]) return '';

    const mimeType = object[property].toLowerCase();

    const types = {
        pdf: ['application/pdf', '.pdf'],
        video: ['video/', '.mp4', '.webm', '.avi', '.mov'],
        image: ['image/', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'],
        audio: ['audio/', '.mp3', '.wav', '.m4a', '.aac', '.flac']
    };

    for (const [type, patterns] of Object.entries(types)) {
        if (patterns.some(p => mimeType.includes(p))) {
            return type;
        }
    }

    return 'unknown'
}

/**
 * @author Edgar Escobedo
 * @description Calculate the credits consumed per document when sent to OCR and Textract
 * @createdDate 03-09-2025
 * @param {[{id:Number | null, name:String, pages:Number }]} documents - List of documents to calculate credits
 * @param {function} t - Function to translate text
 * @returns 
 */
const setCreditsToDocuments = (documents, t) => {
    let docsToOCR = []
    let totalCredits = 0
    const ENV = process.env

    documents.map((doc) => {
        let pages = doc.pages
        let credits = Number(ENV.REACT_APP_OCR_ENTITIES_CREDITS)
        let addPagesOCR = Number(ENV.REACT_APP_OCR_PAGES)
        let addPagesEntities = Number(ENV.REACT_APP_ENTITIES_PAGES)
        const addPagesEmbeddings = Number(ENV.REACT_APP_EMBEDDINGS_PAGES)

        let totalCredtisOCR = countCreditsByPages(pages, credits, addPagesOCR)
        let totalCredtisEntities = countCreditsByPages(pages, credits, addPagesEntities)
        const totalCreditsEmbeddings = countCreditsByPages(pages, credits, addPagesEmbeddings)

        let ocrDoc = {
            id: doc.id,
            name: doc.name,
            pages: doc.pages,
            process: t('digitalVaultUploadView.process.ocr'),
            unitary: `${process.env.REACT_APP_CREDITS_PROCESS_OCR} ${t('digitalVaultUploadView.credits.by')} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_OCR} ${t('digitalVaultUploadView.pages')}`,
            credits: totalCredtisOCR,
            value: true,
            processId: Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_OCR_ID)
        }

        let entitiesDoc = {
            id: doc.id,
            name: doc.name,
            pages: doc.pages,
            process: t('digitalVaultUploadView.process.entity.extraction'),
            unitary: `${process.env.REACT_APP_CREDITS_PROCESS_ENTITY_EXTRACTION} ${t('digitalVaultUploadView.credits.by')} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_ENTITY_EXTRACTION} ${t('digitalVaultUploadView.pages')}`,
            credits: totalCredtisEntities,
            value: true,
            processId: Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID)
        }

        const embeddingsDoc = {
            id: doc.id,
            name: doc.name,
            pages: doc.pages,
            process: t('digitalVaultUploadView.process.embeddings'),
            unitary: `${process.env.REACT_APP_CREDITS_PROCESS_EMBEDDINGS} ${t('digitalVaultUploadView.credits.by')} ${process.env.REACT_APP_NUMBER_PAGES_CREDITS_EMBEDDINGS} ${t('digitalVaultUploadView.pages')}`,
            credits: totalCreditsEmbeddings,
            value: true,
            processId: Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)
        }
        docsToOCR.push(ocrDoc)
        docsToOCR.push(entitiesDoc)
        docsToOCR.push(embeddingsDoc)

        totalCredits = totalCredits + totalCredtisOCR + totalCredtisEntities + totalCreditsEmbeddings
    })

    let data = {
        documentsToOCR: docsToOCR,
        totalCredits
    }
    return data
}

/**
 * @author Edgar Escobedo
 * @description Extracts the domain part from an email address
 * @param {string} email - The email address to extract domain from
 * @returns {string|null} The domain part of the email or null if invalid
 * @createdDate 15-12-2025
 */
const extractEmailDomain = (email) => {
    // Validate input is a string
    if (typeof email !== 'string') return null

    // Trim whitespace and check if empty
    const trimmedEmail = email.trim()
    if (trimmedEmail === '') return null


    // Find the last occurrence of @ symbol
    const atIndex = trimmedEmail.lastIndexOf('@')

    // Check if @ exists and is not at the beginning or end
    if (atIndex === -1 || atIndex === 0 || atIndex === trimmedEmail.length - 1) return null


    // Extract domain part
    const domain = trimmedEmail.slice(atIndex + 1)

    // Check if domain is empty or contains invalid characters
    if (domain === '' || domain.includes('@')) return null

    return domain
}

export { countCreditsByPages, getFileMediaType, setCreditsToDocuments, extractEmailDomain }